module.exports = __webpack_public_path__ + "static/media/icon-twitter.fd05b0b4.svg";